var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',{staticClass:"card shadow-none border-0"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('p',[_vm._v(_vm._s(_vm.data.revision))])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header bg-light"},[_c('span',[_c('i',{staticClass:"fa fa-first-aid"}),_vm._v(" REVISIÓN POR SISTEMAS")])])
}]

export { render, staticRenderFns }